import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import moment from 'moment';
import { combineLatest } from 'rxjs';
import { startWith, takeWhile } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import * as fromDataServices from '../../data-services';
import * as fromShared from '../../shared';
import { LoggingService } from '../../shared/services/logging';

@Component({
    selector: 'ef-job-audit-presenter',
    templateUrl: './job-audit-presenter.component.html',
    styleUrls: ['./job-audit-presenter.component.scss'],
    standalone: false
})
export class JobAuditPresenter
    extends fromShared.EditGrid<fromDataServices.JobAudit.JobAuditModel>
    implements OnInit, OnDestroy, OnChanges {
    @Input() loading = true;
    numCols = 3;
    dropdownItemHeight = environment.dropdownItemHeight;
    moment: any;
    cols: { field: string; header: string }[] = [
        { field: 'StartTime', header: 'StartDate' },
        { field: 'EndTime', header: 'EndDate' },
        { field: 'Result', header: 'Result' }
    ];
    filterFormGroup: UntypedFormGroup;
    private active = true;
    @Output() DateFiltersChanged = new EventEmitter<{
        startDate: Date;
        endDate: Date;
    }>();
    constructor(private log: LoggingService, private cdRef: ChangeDetectorRef) {
        super();
        this.filterFormGroup = new UntypedFormGroup({
            endDate: new UntypedFormControl(new Date()),
            startDate: new UntypedFormControl(moment().add(-1, 'months').toDate())
        });
        this.moment = moment;
    }

    ngOnInit(): void {
        combineLatest([
            this.filterFormGroup.controls['startDate'].valueChanges.pipe(
                startWith(this.filterFormGroup.controls['startDate'].value)
            ),
            this.filterFormGroup.controls['endDate'].valueChanges.pipe(
                startWith(this.filterFormGroup.controls['endDate'].value)
            )
        ])
            .pipe(
                takeWhile(_ => this.active)
                // debounceTime(500)
            )
            .subscribe(x => {
                if (moment(x[0]).isValid() && moment(x[1]).isValid()) {
                    this.DateFiltersChanged.emit({
                        startDate: x[0],
                        endDate: x[1]
                    });
                }

            });
    }
    ngOnDestroy(): void {
        this.active = false;
    }
    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        if (
            changes.items &&
            changes.items.currentValue &&
            changes.items.currentValue.length > 0
        ) {
            this.log.verbose({
                type: 'JobAuditPresenter: ngOnChanges',
                changes
            });
            this.dataTable.multiSortMeta = [
                { field: 'StartTime desc', order: 1 }
            ];
            this.dataTable.sortMultiple();
            this.cdRef.detectChanges();
        }
    }
}
